var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"countDown",on:{"click":_vm.goIndex}},[_vm._v("跳过广告 "+_vm._s(_vm.totalTime))]),_c('img',{staticClass:"img",attrs:{"src":_vm.currImg,"alt":""},on:{"click":_vm.goIndex}})])
}
var staticRenderFns = []

export { render, staticRenderFns }